import { render } from "./RentMeSetup.vue?vue&type=template&id=53f02518&scoped=true"
import script from "./RentMeSetup.vue?vue&type=script&lang=js"
export * from "./RentMeSetup.vue?vue&type=script&lang=js"

import "./RentMeSetup.vue?vue&type=style&index=0&id=53f02518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f02518"]])

export default __exports__